import { schMLSID } from '@aloft/toolkit-shared';
import { z } from 'zod';

export const schMlsListingInfo = z.strictObject({
  mls: schMLSID.or(z.literal('')),
  mlsListingID: z.string(),
});
export type MlsListingInfo = z.infer<typeof schMlsListingInfo>;
